<template>
    <div>
        <Header></Header>
        <div class='contents'>
            <Sidebar/>
            <router-view/>
        </div>
    </div>
</template>

<script>

import Header from '@/components/lab/Header.vue'
import Sidebar from '@/components/lab/Sidebar.vue'

export default {
    name: 'Lab',
    components: {
        Header,
        Sidebar
    },
    data () {
        return {
            id: null,
            requestParams: ''
        }
    },
    created () {
        const self = this

        if (self.$route.query.id) {
            self.id = self.$route.query.id
            self.requestParams = `?id=${self.id}`
        }
    },
    mounted () {
        const self = this

        try {
            self.axios.post(`${process.env.API_URL}/sessionCheck`).then((res) => {
                if (res.data.type !== 'admin' && res.data.type !== 'lab') {
                    self.$root.$emit('notification', 'is-danger', '権限がありません')
                    self.$router.push('/login')
                }
                self.type = res.data.type
            }).catch((e) => {
                throw e
            })
        } catch (e) {
            this.$root.$emit('notification', 'is-danger', '予期せぬエラーが発生しました')
        }
    },
    methods: {
    }
}
</script>

<style scoped>

.contents {
    display: flex;
}

.main {
    padding-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/routes/Lab.vue